import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CommmentsEntity } from './comments.entity';
import { CommentsService } from './comments.service';
import { CommentsController } from './comments.controller';
import { PostPointsEntity } from '../post/post-points.entity';
import { PostEntity } from '../post/post.entity';
import { NotificationsEntity } from '../notifications/notifications.entity';

@Module({
    imports: [
        TypeOrmModule.forFeature([CommmentsEntity,PostEntity,PostPointsEntity,NotificationsEntity])
    ],
    controllers:[CommentsController],
    providers:[CommentsService],
    exports:[CommentsService],
})
export class CommentsModule {}

